"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTRICTED_STATUSES = void 0;
const enquiryStates_1 = require("./enquiryStates");
exports.RESTRICTED_STATUSES = [
    enquiryStates_1.SLUGS.QA_READY,
    enquiryStates_1.SLUGS.QA_ON_HOLD,
    enquiryStates_1.SLUGS.READY_FOR_SALE,
    enquiryStates_1.SLUGS.SALE_ACTIVE,
    enquiryStates_1.SLUGS.FOR_SALE,
    enquiryStates_1.SLUGS.UNSOLD_NO_BIDS,
    enquiryStates_1.SLUGS.UNSOLD_BELOW_RESERVE_BID,
    enquiryStates_1.SLUGS.UNDER_OFFER,
    enquiryStates_1.SLUGS.SOLD_CONFIRMED,
    enquiryStates_1.SLUGS.SOLD_DOCUMENTS_REVIEWED,
    enquiryStates_1.SLUGS.SOLD_INVOICE_RAISED,
    enquiryStates_1.SLUGS.SOLD_WAIT,
    enquiryStates_1.SLUGS.SOLD_INVOICE_PAID,
];
//# sourceMappingURL=restrictedStatuses.js.map